import React from "react";
import SEO from "@/components/SEO";

export default function PrivacyPage() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Bill Forge Privacy Policy. Learn how we collect, use, and protect your data. Your privacy is important to us. Read our comprehensive privacy policy."
        path="/privacy"
      />
      <div className="bg-background">
      <section className="py-20 bg-gradient-to-b from-primary/5 to-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold font-manrope mb-6">
            Privacy Policy
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </section>

      <section className="py-20 bg-background">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-card border border-border rounded-2xl p-8 md:p-12">
            <div className="prose prose-slate max-w-none">
              <h2 className="text-2xl font-bold font-manrope mb-4">1. Information We Collect</h2>
              <p className="text-muted-foreground mb-6">
                We collect information you provide directly to us, such as when you create an
                account, create invoices, or communicate with us. This includes your name, email
                address, organization details, and business information.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">2. How We Use Your Information</h2>
              <p className="text-muted-foreground mb-6">
                We use the information we collect to provide, maintain, and improve our services,
                process transactions, send you technical notices and support messages, and respond
                to your comments and questions.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">3. Information Sharing</h2>
              <p className="text-muted-foreground mb-6">
                We do not sell your personal information. We may share your information with
                service providers who perform services on our behalf, such as hosting and data
                analysis, subject to strict confidentiality obligations.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">4. Data Security</h2>
              <p className="text-muted-foreground mb-6">
                We implement appropriate technical and organizational measures to protect your
                personal information against unauthorized access, alteration, disclosure, or
                destruction.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">5. Data Retention</h2>
              <p className="text-muted-foreground mb-6">
                We retain your personal information for as long as necessary to provide our
                services and fulfill the purposes outlined in this privacy policy.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">6. Your Rights</h2>
              <p className="text-muted-foreground mb-6">
                You have the right to access, correct, or delete your personal information. You
                may also opt out of marketing communications or request a copy of your data.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">7. Contact</h2>
              <p className="text-muted-foreground">
                For questions about this Privacy Policy, please contact us at
                info@codingwithdevam.cloud
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
